import * as React from "react";
import { connect } from "react-redux";
import { IReduxState } from "reducers";
import Loading from "components/loading";

interface IProps {
  email: string;
  userId: number;
}

interface IState {
  loading: boolean;
}
class ChatRoom extends React.Component<IProps, IState> {

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
    };
    this.onInit = this.onInit.bind(this);
  }

  public onInit(e) {
    if (e === "success") {
      const conversationDetail = {
        botIds: ["bot1"],
      };
      (window as any).Kommunicate.startConversation(conversationDetail, (response) => {
        this.setState({ loading: false });
      });
    }
  }

    public componentWillMount() {
      this.setState({loading: true});
    }
    public componentDidMount() {
      (window as any).kommunicate = null;
      this.addKommunicateBot((window as any).kommunicate || {}, this.props.email, this.props.userId);
    }
    public render() {
      return (
        <div className="container-fluid" style={{width: "100%", height: "100%",
          margin: 0,
          padding: 0,
          maxWidth: "100%"}}>
          <Loading
          active={this.state.loading}/>
        </div>
      );
    }

  private addKommunicateBot(m: any, email: string, userId: number) {
    const o = {
      appId: "29bc19e4ff002556a54c2c9087ff5bdfb",
      isAnonymousChat: true,
      conversationTitle: "Hello!",
      userId,
      userName: email,
      email,
      botIds: ["shubh-bot"],
      onInit: this.onInit,
    };
    const s = document.createElement("script");
    s.type = "text/javascript";
    s.async = true;
    s.id = "kommunicate-bot";
    s.src = "https://api.kommunicate.io/kommunicate.app";
    document.getElementsByTagName("head")[0].appendChild(s);
    (window as any).kommunicate = m;
    m._globals = o;
  }
}

const mapStateToProps = (state: IReduxState): IProps => {
  const auth = state.login.auth ? state.login.auth : null;
  return {
    email: auth ? auth.email : null,
    userId: auth ? auth.userId : null,
  };
};
export default connect<IProps, {}, {}>(mapStateToProps)(ChatRoom);
